import { IGResponse } from "@common/models";
import { ITravelItinerary } from "@common/models/CMS";
import Title from "@components/general/Title";
import ItineraryWidget from "@components/Widgets/ItineraryWidget";
import { TRAVEL_ITINERARY, useApolloQuery } from "@service/graphql";
import Translate from "@service/Translate";
import { FC } from "react";
import { useParams } from "react-router";

interface ITravelItineraryParam {
    id: string;
}

const TravelItinerary: FC = () => {
    const { tr } = Translate;
    const { id } = useParams<ITravelItineraryParam>();
    const { data, loading } = useApolloQuery<IGResponse<ITravelItinerary[]>>(TRAVEL_ITINERARY, { variables: { localizationSet: id } });
    const travelItinerary = data?.travelItinerary[0] || {};

    return (
        <div className="travel-itinerary">
            {
                loading ? '' :
                    <>
                        <div className="travel-itinerary-header">
                            <div className="container">
                                <div className="travel-itinerary-header-title">{tr("travel_itinerary")}</div>
                                <h1>{travelItinerary.displayText}</h1>
                                <div className="travel-itinerary-header-description" dangerouslySetInnerHTML={{ __html: travelItinerary.description?.html || "" }} />
                            </div>
                        </div>
                        <ItineraryWidget dataSource={travelItinerary} scrollIntoView />
                        <div className="travel-itinerary-content">
                            <div className="container">
                                <div className="text-center mb">
                                    <Title text={tr("travel_itinerary_details")} border='center' />
                                </div>
                                <div className="travel-itinerary-content-item">
                                    <div className="row flex">
                                        <div className="col-2-3 col-sm-1-1">
                                            <div className="travel-itinerary-content-title mb">{tr("what_included")}:</div>
                                            <div dangerouslySetInnerHTML={{ __html: travelItinerary.included?.html || "" }} />
                                        </div>
                                        <div className="col-1-3 col-sm-1-1">
                                            <div className="travel-itinerary-content-title mb">{tr("what_not_included")}:</div>
                                            <div dangerouslySetInnerHTML={{ __html: travelItinerary.notIncluded?.html || "" }} />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row flex">
                                        <div className="col-1-2 col-sm-1-1">
                                            {
                                                travelItinerary.packagePrice &&
                                                <>
                                                    <div className="travel-itinerary-content-title mb">{tr("package_price")}</div>
                                                    <div dangerouslySetInnerHTML={{ __html: travelItinerary.packagePrice.html || "" }} />
                                                </>
                                            }
                                            {
                                                travelItinerary.termsConditions &&
                                                <>
                                                    <div className="travel-itinerary-content-title mb mt">{tr("terms_and_conditions")}</div>
                                                    <div dangerouslySetInnerHTML={{ __html: travelItinerary.termsConditions.html || "" }} />
                                                </>
                                            }
                                            {
                                                travelItinerary.paymentTerms &&
                                                <>
                                                    <div className="travel-itinerary-content-title mb mt">{tr("payment_terms")}</div>
                                                    <div dangerouslySetInnerHTML={{ __html: travelItinerary.paymentTerms.html || "" }} />
                                                </>
                                            }
                                        </div>
                                        <div className="col-1-2 col-sm-1-1">
                                            {
                                                travelItinerary.cancellationPolicy &&
                                                <>
                                                    <div className="travel-itinerary-content-title mb">{tr("cancellation_policy")}</div>
                                                    <div dangerouslySetInnerHTML={{ __html: travelItinerary.cancellationPolicy.html || "" }} />
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </div>
    )
}

export default TravelItinerary;